import React from 'react';
import { Badge } from 'react-bootstrap';
import styles from './AlertsBadge.module.css';
import { NotificationStats } from 'model';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FloComponentProps } from 'components';

interface AlertsBadgeProps extends FloComponentProps {
  stats: NotificationStats;
  displayLabel?: boolean;
};

export const AlertsBadge: React.FC<AlertsBadgeProps> = ({ stats, className, displayLabel = false }) => {
  const { t } = useTranslation();
  const alertCount = stats.criticalCount > 0 ? stats.criticalCount : stats.warningCount > 0 ? stats.warningCount : stats.infoCount;
  return (
    <>
      { (stats.criticalCount > 0 || stats.warningCount > 0) ?
        <Badge
          className={classnames(
            styles.root,
            className,
            { [styles.critical]: stats.criticalCount > 0 },
            { [styles.warning]: stats.criticalCount === 0 && stats.warningCount > 0 },
            { [styles.info]: stats.criticalCount === 0 && stats.warningCount === 0 && stats.infoCount > 0 },
          )}
          pill
          variant={ stats.criticalCount > 0 ? 'danger' : stats.warningCount > 0 ? 'warning' : 'success' }
        >
          { `${alertCount}${displayLabel ? ` ${t('alert-badge-label', { count: alertCount })}` : ''}` }
        </Badge>
        : 
        <Badge
          className={classnames(
            styles.root,
            className,
            styles.success,
          )}
          pill
          variant= 'success' 
        >
          0
        </Badge>
      }
    </>
  )
}